<template>
  <div>
    <b-container style="position: relative" class="downtown pt-5">
      <b-row class="">
        <b-col cols="12" style="position: relative" class="intro-text mt-md-4">
          <div class="textOverSlider d-none d-md-block p-4">
            <h1>
              FOR THOSE<br />
              WHO VALUE...<br />
              CONVENIENT<br />
              LOCAL SHOPPING<br />
              &amp; DINING<br />
            </h1>
            <p>
              MVP is perfectly positioned to take advantage of South Barrie's ever-growing selection of convenient urban amenities. There are numerous major
              shops and plazas along Mapleview Drive and Big Bay Point Road. Pick up everyday essentials just 5 minutes away at Walmart or Costco. Sample over a
              dozen local restaurants less than 10 minutes away. Hop on Highway 400 and arrive at Tanger Outlets in less than 15 minutes, or head downtown to
              enjoy great dining and shopping destinations along Bayfield Road.
            </p>
          </div>

          <div id="carouselExample2" class="carousel slide" data-bs-ride="carousel">
            <!-- Indicator styling is in the index page -->
            <div class="carousel-indicators">
              <button type="button" data-bs-target="#carouselExample2" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
              <button type="button" data-bs-target="#carouselExample2" data-bs-slide-to="1" aria-label="Slide 2"></button>
              <button type="button" data-bs-target="#carouselExample2" data-bs-slide-to="2" aria-label="Slide 3"></button>
              <button type="button" data-bs-target="#carouselExample2" data-bs-slide-to="3" aria-label="Slide 4"></button>
              <button type="button" data-bs-target="#carouselExample2" data-bs-slide-to="4" aria-label="Slide 5"></button>
              <button type="button" data-bs-target="#carouselExample2" data-bs-slide-to="5" aria-label="Slide 6"></button>
            </div>
            <div class="carousel-inner">
              <div class="carousel-item backgroundImageStyle active" fluid data-bs-interval="4000" style="background-image: url('/img/newSlider/downtown-5.jpg');">
                <!-- <img src="/img/newSlider/downtown-5.jpg" fluid class="carouselImage" alt="downtown 5" /> -->
              </div>
              <div class="carousel-item backgroundImageStyle" fluid data-bs-interval="4000" style="background-image: url('/img/newSlider/downtown.jpg');">
                <!-- <img src="/img/newSlider/downtown.jpg" fluid class="carouselImage" alt="downtown" /> -->
              </div>
              <div class="carousel-item backgroundImageStyle" fluid data-bs-interval="4000" style="background-image: url('/img/newSlider/downtown-2.jpg');">
                <!-- <img src="/img/newSlider/downtown-2.jpg" fluid class="carouselImage" alt="downtown 2" /> -->
              </div>
              <div class="carousel-item backgroundImageStyle" fluid data-bs-interval="4000" style="background-image: url('/img/newSlider/downtown-3.jpg');">
                <!-- <img src="/img/newSlider/downtown-3.jpg" fluid class="carouselImage" alt="downtown 3" /> -->
              </div>
              <div class="carousel-item backgroundImageStyle" fluid data-bs-interval="4000" style="background-image: url('/img/newSlider/downtown-4.jpg');">
                <!-- <img src="/img/newSlider/downtown-4.jpg" fluid class="carouselImage" alt="downtown 4" /> -->
              </div>
              <!-- <div class="carousel-item" data-bs-interval="4000">
                <img src="/img/newSlider/downtown-6.jpg" fluid class="d-block w-100" alt="downtown 6" />
              </div> -->
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample2" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExample2" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
        </b-col>
      </b-row>
      <div class="textOverSliderMobile d-md-none">
        <h1>FOR THOSE WHO VALUE... CONVENIENT LOCAL SHOPPING &amp; DINING</h1>
        <p>
          MVP is perfectly positioned to take advantage of South Barrie's ever-growing selection of convenient urban amenities. There are numerous major shops
          and plazas along Mapleview Drive and Big Bay Point Road. Pick up everyday essentials just 5 minutes away at Walmart or Costco. Sample over a dozen
          local restaurants less than 10 minutes away. Hop on Highway 400 and arrive at Tanger Outlets in less than 15 minutes, or head downtown to enjoy great
          dining and shopping destinations along Bayfield Road.
        </p>
      </div>
      <!-- <b-col md="2" offset-md="1" offset-lg="2" class="d-none d-sm-none d-md-block arrows">
        <b-row>
          <b-col @click="prev">
            &larr;
          </b-col>
          <b-col @click="next">
            &rarr;
          </b-col>
        </b-row>
      </b-col> -->
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slide: 0,
      sliding: null,
      // landingpageSlick: {
      //   speed: 1500,
      //   autoplay: true,
      //   autoplaySpeed: 2500,
      //   slidesToShow: 1,
      //   arrows: false,
      //   infinite: true,
      //   dots: true
      // }
    };
  },
  mounted() {},
  methods: {
    next() {
      this.$refs.myCarousel.next();
    },
    prev() {
      this.$refs.myCarousel.prev();
    },
  },
};
</script>
<style lang="scss">
.downtown {
  .carousel-wrapper {
    max-width: 100vw;
    margin: 0 auto;
  }

  .backgroundImageStyle{
    min-height: 50vh;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    @media screen and (max-width: 1024px) {
      min-height: 35vh;
    }

  }

  // .image-holder {
  //   width: 100%;
  //   height: auto;
  //   object-fit: cover;
  //   img {
  //     @media screen and (min-width: 768px) {
  //       width: 420px;
  //     }
  //   }
  // }
  .slick-arrow {
    background-color: red;
  }
  .slick-track {
    @media screen and (min-width: 768px) {
      padding-left: calc(100% - 350px);
    }
  }
  .textOverSlider {
    width: 45%;
    color: red;
    position: absolute;
    left: 14%;
    height: 100%;
    background-color: white;
    z-index: 10;
    h1 {
      font-weight: normal;
      font-size: 30px;
      color: #f05b2d;
    }
    p {
      font-size: 14px;
      margin-bottom: 12px;
      color: black;
    }
    @media screen and (min-width: 768px) and (max-width: 1000px) {
      h1 {
        font-size: 30px !important;
      }
      .waves {
        display: none;
      }
      p {
        margin-bottom: 0px;
      }
    }
  }
  .textOverSliderMobile {
    text-align: center;
    padding-top: 25px;
    h1 {
      font-weight: normal;
      font-size: 25px;
      color: #f05b2d;
    }
    p {
      font-size: 14px;
      // margin-bottom: 12px;
    }
  }
}
</style>
